var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.788 18.488a1 1 0 0 0 1.263-.124l4.95-4.95 4.95 4.95a1 1 0 0 0 .706.293 1 1 0 0 0 .707-1.707L13.415 12l4.95-4.95a1 1 0 0 0-1.413-1.414L12 10.586l-4.95-4.95A1 1 0 0 0 5.637 7.05l4.95 4.95-4.95 4.95a1 1 0 0 0 .151 1.538",
    clipRule: "evenodd"
  })));
};
export default SvgClose;